/* unplugin-vue-components disabled */import { render } from "./FooterTabBar.vue?vue&type=template&id=606933c0&ts=true"
import script from "./FooterTabBar.vue?vue&type=script&lang=ts"
export * from "./FooterTabBar.vue?vue&type=script&lang=ts"

import "./FooterTabBar.vue?vue&type=style&index=0&id=606933c0&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__